const ENV = 'prod'
const APP_BASE_URL = 'https://barryandbonna.com'
const STRIPE_PUBLISHABLE_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY

export { APP_BASE_URL as API_BASE_URL, ENV, STRIPE_PUBLISHABLE_KEY }
